// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--+ZePN";
export var container = "Footer-module--container--cIk5r";
export var copyRight = "Footer-module--copyRight--5ojFb";
export var meta = "Footer-module--meta--raF8b";
export var ko = "Footer-module--ko--A8b46";
export var en = "Footer-module--en--uExVn";
export var media = "Footer-module--media--1WNxz";